export enum PlaceholderId {
    X = 'x',
    Y = 'y',
    Y2 = 'y2',
    FlatTableColumns = 'flat-table-columns',
    Geopoint = 'geopoint',
    Geopoligon = 'geopolygon',
    Measures = 'measures',
    Size = 'size',
    Points = 'points',
    Dimensions = 'dimensions',
    PivotTableColumns = 'pivot-table-columns',
    PivotTableRows = 'rows',
    Polyline = 'polyline',
    Grouping = 'grouping',
    Heatmap = 'heatmap',
    Colors = 'colors',
    DashboardFilters = 'dashboard-filters',
    DashboardParameters = 'dashboard-parameters',
    Filters = 'filters',
    Labels = 'labels',
    LayerFilters = 'layer-filters',
    Segments = 'segments',
    Shapes = 'shapes',
    Sort = 'sort',
    Tooltips = 'tooltips',
    Available = 'available',
}
